<template>
    <v-autocomplete
        :items="data.data || []"
        item-text="name"
        item-value="id"
        :value="value"
        :label="label || $t('attributes.role')"
        @input="$emit('input', $event)"
        :clearable="clearable"
        :outlined="outlined"
        :error-messages="errorMessages"
        :chips="chips"
        :return-object="false"
        :multiple="multiple"
    ></v-autocomplete>
</template>
<script>
import { mapState } from "vuex";

export default {
    name: "RolesField",

    props: {
        value: [String, Number, Array],
        label: { type: String },
        errorMessages: [String, Array],
        clearable: { type: Boolean, default: false },
        outlined: { type: Boolean, default: false },
        chips: { type: Boolean, default: false },
        multiple: { type: Boolean, default: true }
    },

    computed: {
        ...mapState({
            data: state => state.role.items
        })
    },
    created() {
        if (!this.data || !this.data.data) this.$store.dispatch("role/fetchAll");
    }
};
</script>
